import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IGrowthStage, IGrowthStageMappedGetRequest, IGrowthStageSortOrderItem } from '../insecta.models';
import { growthStageSort } from '../../../common/sorts';

@Injectable({
  providedIn: 'root'
})
export class GrowthStageAdminService extends InsectaServiceBase {
  public addGrowthStage(growthStage: IGrowthStage): Observable<string> {
    return this.post<string>(`/admin/growthstages`, `v1`, {
      name: growthStage.name,
      isActive: growthStage.isActive,
      sortOrder: growthStage.sortOrder,
      username: growthStage.actionBy
    });
  }

  public getGrowthStage(id: string): Observable<IGrowthStage> {
    return this.get<IGrowthStage>(`/admin/growthstages/${id}`, 'v1');
  }

  public getGrowthStages(includeInActive: boolean | null | undefined): Observable<IGrowthStage[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IGrowthStage[]>(`/admin/growthstages`, 'v1').pipe(
      map((results) => [...results].filter((x: IGrowthStage) => includeInActive || x.isActive)),
      map((results) => [...results].sort((a: IGrowthStage, b: IGrowthStage) => growthStageSort(a, b)))
    );
  }

  public getGrowthStagesAll(): Observable<IGrowthStage[]> {
    return this.getGrowthStages(true);
  }

  public updateGrowthStage(growthStage: IGrowthStage): Observable<any> {
    return this.put<IGrowthStage>(`/admin/growthstages/${growthStage.id}`, `v1`, {
      id: growthStage.id,
      name: growthStage.name,
      isActive: growthStage.isActive,
      username: growthStage.actionBy,
      sortOrder: growthStage.sortOrder
    });
  }
  updateGrowthStageSortOrders(items: IGrowthStageSortOrderItem[], username: string): Observable<void> {
    return this.put<void>(`/admin/growthstages/sortorder`, 'v1', { items: items, username: username });
  }

  public getGrowthStagesMapped(
    catalogContainerInsectGrowthStage?: string,
    catalogInsectVariantId?: string
  ): Observable<IGrowthStageMappedGetRequest> {
    if (!isEmpty(catalogInsectVariantId) && !isEmpty(catalogContainerInsectGrowthStage)) {
      return this.get<IGrowthStageMappedGetRequest>(
        `/admin/growthstages/ByCatalogInsectVariantGrowthStageId/${catalogInsectVariantId}/${catalogContainerInsectGrowthStage}`,
        'v1'
      );
    }
    if (!isEmpty(catalogContainerInsectGrowthStage)) {
      return this.get<IGrowthStageMappedGetRequest>(
        `/admin/growthstages/ByCatalogContainerInsectGrowthStageId/${catalogContainerInsectGrowthStage}`,
        'v1'
      );
    }
    if (!isEmpty(catalogInsectVariantId)) {
      return this.get<IGrowthStageMappedGetRequest>(`/admin/varianttypes/ByCatalogInsectVariantId/${catalogInsectVariantId}`, 'v1');
    }
    return null as any;
  }
}
